import {
  TTabKey,
} from './audit-trail.ts';

const tabs: Record<TTabKey, string> = {
  settings: 'Ustawienia',
  events: 'Zdarzenia',
};

export default {
  tabs,
};
